import React, { useState, useRef, useEffect, useCallback } from "react";
import {
  Form,
  Input,
  Button,
  Space,
  Typography,
  Card,
  Col,
  Row,
  TimePicker,
  notification,
  DatePicker,
  Select,
  Modal,
  message,
  Popconfirm,
  Spin,
  Alert,
} from "antd";
import {
  AimOutlined,
  DeleteOutlined,
  LoadingOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";

import { useSelector } from "react-redux";
import "../style.css";
import cargarDeptosMunicipios from "../../../services/departMunic/deptosMunicipiosServices";

//Mapa
import {
  MapContainer,
  TileLayer,
  LayersControl,
  useMapEvents,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import ImagenUploader from "./ImagenUploader";
import insertVisitaTecnica from "../../../services/visitas_tecnicas/visita_tecnica/insertVisitaTecnicaService";
import updateVisitaTecnica from "../../../services/visitas_tecnicas/visita_tecnica/putVisitaTecnicaService";

import moment from "moment";
import getParticipanteCodigo from "../../../services/participants/getParticipanteCodigo";
import obtenerTematicasxFactores from "../../../services/visitas_tecnicas/getTemmaticasxFactoresService";
import getUltimaVisitaTecnica from "../../../services/visitas_tecnicas/visita_tecnica/getUltimaVisitaService";
import FirmaCanvas from "../../firma_electronica/firma";
import TextArea from "antd/es/input/TextArea";
import { uploadSoportesVisitaTecnica } from "../../../services/visitas_tecnicas/visita_tecnica/insertSoportesVisitaTecnica";
import { updateSoportesVisitaTecnica } from "../../../services/visitas_tecnicas/visita_tecnica/updateSoportesVisitaTecnica copy";
import getVisitaTecnicaById from "../../../services/visitas_tecnicas/visita_tecnica/getVisitaTecnicaByIdService";
import PdfAlmacenarVisitaTecnica from "./pdfVisitaTecnicaAlmacenar";
import { pdf } from "@react-pdf/renderer";
import { postSoporteVisitaTecnicaPatti } from "../../../services/visitas_tecnicas/visita_tecnica/postAlmacenarSoporteVisitaTecnicaPaati";
import deleteVisitaTecnica from "../../../services/visitas_tecnicas/visita_tecnica/deleteVisitaTecnicaService";


const { Title } = Typography;
const { Option } = Select;
const { BaseLayer } = LayersControl;

const FormularioVisitaTecnica = ({ initialData, onClose, fetchData }) => {
  const [form] = Form.useForm();
  const [formLoaded, setFormLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const usernameFromState = useSelector((state) => state.auth.user);
  const [codigoSIRR, setCodigoSIRR] = useState("");
  const [datosProyecto, setDatosProyecto] = useState({});
  const [modalVisible, setModalVisible] = useState(null);
  const [codigoSIRRModal, setCodigoSIRRModal] = useState("");

  const [departamentosxmunicipio, setDepartamentosxmunicipio] = useState("");
  const [departamentos, setDepartamentos] = useState([]);
  const [departamentoSeleccionado, setDepartamentoSeleccionado] = useState("");
  const [municipios, setMunicipios] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [isOtra, setIsOtra] = useState(false);
  const [modalidadSesionCapacitacion, setModalidadSesionCapacitacion] =
    useState(false);

  const [dataTematicasxFactores, setDataTematicasxFactores] = useState([]);
  // Agregar nuevo estado para áreas filtradas
  const [areasFiltradas, setAreasFiltradas] = useState([]);
  const [tematicasFiltradas, setTematicasFiltradas] = useState([]);
  const [factoresFiltrados, setFactoresFiltrados] = useState([]);
  const [ultima_visita, setUltima_visita] = useState([]);

  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");


const [isLoadingGeneral, setIsLoadingGeneral] = useState(true);
const [cargaConError, setCargaConError] = useState(false);
const [erroresCarga, setErroresCarga] = useState([]);

  // Estados para controlar carga y estado de cada campo de imagen
  const [loadingStatus, setLoadingStatus] = useState({});
  const [readyStatus, setReadyStatus] = useState({});


  const [isDirty, setIsDirty] = useState(false);

    // Lista de nombres de campos de imagen
  const imageFields = [
    'fotografia_usuario',
    'fotografias_lugar',
    'fotografia_finalidad',
    'fotografia_acta',
    'fotografia_actividad'
  ];

const [progresoCarga, setProgresoCarga] = useState({
  departamentos: false,
  tematicas: false,
  imagenes: false,
});


const mapRef = useRef();

  //Inicializar el marcador del mapa
  const [markerPosition, setMarkerPosition] = useState(() => {
    if (form?.latuser && form?.lnguser) {
      return [form.latuser, form.lnguser];
    } else {
      return [4.570868, -74.297333];
    }
  });

  // Agregar manejador para el cambio de tema
  const handleTemaChange = (value, option, index) => {
    const currentValues = form.getFieldValue("lista_capacitaciones");

    const id = Number(option.key); // Convierte el key a número
    // Filtrar las áreas que corresponden al tema seleccionado
    const areasDelTema = dataTematicasxFactores.areasTematicas.filter(
      (area) => area.tema === id
    );
    setAreasFiltradas(areasDelTema);

    // Actualiza el tema y limpia el área temática seleccionada
    form.setFieldsValue({
      lista_capacitaciones: currentValues.map((item, i) => {
        if (i === index) {
          return {
            ...item,
            tema: value, // Actualiza el tema seleccionado
            area: undefined, // Limpia el campo del área temática
            tematica: undefined,
            factor: undefined,
          };
        }
        return item;
      }),
    });
  };

  // Agregar manejador para el cambio de area tematica
  const handleAreaTematicaChange = (option, value, index) => {
    const currentValues = form.getFieldValue("lista_capacitaciones");

    const id = Number(value.key); // Convierte el key a número

    // Filtrar las áreas que corresponden al tema seleccionado
    const tematicasxarea = dataTematicasxFactores.tematicas.filter(
      (tematica) => tematica.id_temaxarea === id
    );
    setTematicasFiltradas(tematicasxarea);
    // Actualiza el tema y limpia el área temática seleccionada
    form.setFieldsValue({
      lista_capacitaciones: currentValues.map((item, i) => {
        if (i === index) {
          return {
            ...item,
            tematica: undefined,
            factor: undefined,
          };
        }
        return item;
      }),
    });
  };

  const handleTematicaChange = (option, value, name) => {
    const id = Number(value.key); // Convierte el key a número

    // Encontrar la temática correspondiente al ID
    const tematicaSeleccionada = dataTematicasxFactores.tematicas.find(
      (tematica) => tematica.id === id
    );

    if (tematicaSeleccionada) {
      // Encontrar el factor relacionado con la temática seleccionada
      const factorSelect = factoresFiltrados.find(
        (factor) => factor.id === tematicaSeleccionada.id_factor
      );

      // Actualiza dinámicamente los factores en el formulario
      form.setFieldsValue({
        lista_capacitaciones: form
          .getFieldValue("lista_capacitaciones")
          .map((item, index) => {
            if (index === name) {
              return {
                ...item,
                factor: factorSelect.factor,
              };
            }
            return item;
          }),
      });
    } else {
      setFactoresFiltrados([]); // Limpiar factores si no se encuentra una temática
    }

    // Limpiar el área seleccionada cuando cambia el tema
    form.setFieldsValue({ factor: undefined });
  };

  const actualizarselectores = async () => {
    setAreasFiltradas([]);
    setTematicasFiltradas([]);
  };

const cargarTematicasxSectores = useCallback(async () => {
  try {
    const response = await obtenerTematicasxFactores();

    if (!response.success) {
      throw new Error(
        response.message || "No fue posible cargar las temáticas"
      );
    }

    setDataTematicasxFactores(response.data);
    setFactoresFiltrados(response.data.factores);

    return response.data;

  } catch (error) {
    console.error("Error al cargar datos:", error);
    throw error;
  }
}, []);

  const obtenerUltimaVisitaTecnica = async (id_participante) => {
    try {
      const response = await getUltimaVisitaTecnica(id_participante);
      if (response.success) {
        form.setFieldsValue({
          numero_visita: response.ultima_visita,
        });
        setUltima_visita(response.ultima_visita);
      } else {
        console.error("Error al cargar tematicas y factores", response.message);
        notification.error({
          message: "Error",
          description: "No se pudo obtener el número de la última visita",
        });
      }
    } catch (error) {
      console.error("Error al cargar datos:", error);
      notification.error({
        message: "Error",
        description: "Error al obtener el número de la última visita",
      });
    }
  };
  // Componente para el marcador y actualizar latitud, longitud y altitud en el formulario
  const LocationMarker = () => {
    useMapEvents({
      async click(e) {
        const { lat, lng } = e.latlng;

        // Actualizar latitud, longitud y posición del marcador
        setLatitude(lat.toFixed(6));
        setLongitude(lng.toFixed(6));
        setMarkerPosition([lat, lng]);
        form.setFieldsValue({
          latuser: lat.toFixed(6),
          lnguser: lng.toFixed(6),
        });
      },
    });

    return null; // Este componente no necesita renderizar nada visible
  };

  //Obtener datos de geolocalización or mi ubicación
  const handleLocateClick = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;

          // Actualizar los estados con la latitud y longitud
          const latNum = Number(latitude.toFixed(6)); // Asegúrate de que sea un número
          const lngNum = Number(longitude.toFixed(6)); // Asegúrate de que sea un número

          setLatitude(latNum);
          setLongitude(lngNum);
          setMarkerPosition([latNum, lngNum]);

          // Configurar los valores del formulario
          form.setFieldsValue({
            latuser: latNum,
            lnguser: lngNum,
          });

          const map = mapRef.current;
          if (map) {
            // Espera a que el mapa esté listo
            setTimeout(() => {
              map.flyTo([latNum, lngNum], 13); // Mover el mapa a la ubicación actual
            }, 100); // Ajusta el tiempo según sea necesario
          }
        },
        (error) => {
          console.error("Error obteniendo la ubicación:", error);
          // Puedes agregar lógica aquí para manejar el error, como mostrar un mensaje al usuario.
        }
      );
    } else {
      console.error("Geolocalización no es soportada por este navegador.");
    }
  };

  //maneja el cambio de estado del departamento
  const handleDepartamentoChange = (valor) => {
    setMunicipios([]);
    form.setFieldsValue({ municipio: undefined });
    setDepartamentoSeleccionado(valor);
    const lista_municipios = departamentosxmunicipio.find(
      (dep) => dep.nombre_departamento === valor
    );

    if (lista_municipios && lista_municipios.municipios) {
      // Ordenar la lista de municipios alfabéticamente por nombre
      const municipiosOrdenados = lista_municipios.municipios.sort((a, b) => {
        if (a.nombre_municipio < b.nombre_municipio) return -1;
        if (a.nombre_municipio > b.nombre_municipio) return 1;
        return 0;
      });

      // Actualizar el estado con la lista de municipios ordenada
      setMunicipios(municipiosOrdenados);
    } else {
      setMunicipios([]);
      form.setFieldsValue({ municipio: undefined });
    }
  };

const obtenerdepartamentos = useCallback(async () => {
  try {
    setDepartamentos([]);
    form.setFieldsValue({ departamentos: [] });

    const { data } = await cargarDeptosMunicipios();

    setDepartamentosxmunicipio(data);

    const uniqueDepartamentos = data.map((departamento) => ({
      id: departamento.oid_departamento,
      nombre: departamento.nombre_departamento,
    }));

    setDepartamentos(uniqueDepartamentos);

    return data;

  } catch (error) {
    console.error("Error al obtener departamentos:", error);
    throw error;
  }
}, [form]);

 // Handlers para cada instancia
  const handleLoadingChange = (name, isLoading) => {
    setLoadingStatus(prev => ({ ...prev, [name]: isLoading }));
  };

  const handleStatusChange = (name, isReady) => {
    setReadyStatus(prev => ({ ...prev, [name]: isReady }));
  };

    // Función que determina si todas las imágenes están listas
  const allImagesReady = () => {
    // Si algún campo está cargando, no está listo
    const hasLoading = Object.values(loadingStatus).some(v => v === true);
    if (hasLoading) return false;

    // Verificar que todos los campos tengan estado ready y sea true
    for (const field of imageFields) {
      // Si aún no se ha registrado el estado (undefined), lo consideramos no listo
      if (readyStatus[field] === undefined) return false;
      if (readyStatus[field] === false) return false;
    }
    return true;
  };


    // Detectar cambios en cualquier campo del formulario
  const onValuesChange = (changedValues, allValues) => {
    checkIfDirty();
  };

  
  // Función para verificar si el formulario ha cambiado
  const checkIfDirty = () => {
    const currentValues = form.getFieldsValue();
    // Comparación profunda con los valores iniciales
    const initial = initialData.current || {};
    // Usamos JSON.stringify para comparar (considerar que las imágenes pueden ser arrays grandes)
    const isEqual = JSON.stringify(currentValues) === JSON.stringify(initial);
    setIsDirty(!isEqual);
  };

// Definir funciones onChange estables para cada campo de imagen

const handleFotografiaUsuarioChange = useCallback((imagenesBase64) => {
  form.setFieldsValue({ fotografia_usuario: imagenesBase64 });
}, [form]);

const handleFotografiasLugarChange = useCallback((imagenesBase64) => {
  form.setFieldsValue({ fotografias_lugar: imagenesBase64 });
}, [form]);

const handleFotografiaFinalidadChange = useCallback((imagenesBase64) => {
  form.setFieldsValue({ fotografia_finalidad: imagenesBase64 });
}, [form]);

const handleFotografiaActaChange = useCallback((imagenesBase64) => {
  form.setFieldsValue({ fotografia_acta: imagenesBase64 });
}, [form]);

const handleFotografiaActividadChange = useCallback((imagenesBase64) => {
  form.setFieldsValue({ fotografia_actividad: imagenesBase64 });
}, [form]);


useEffect(() => {
  let cancelado = false;
  const cargarFormularioCompleto = async () => {
    setIsLoadingGeneral(true);
    setCargaConError(false);
    setErroresCarga([]);
    setFormLoaded(false);

    setProgresoCarga({
      departamentos: false,
      tematicas: false,
      imagenes: false,
    });

    const errores = [];

    try {
      // ============================================================
      // 1. CARGAR DEPARTAMENTOS
      // ============================================================
      try {
        await obtenerdepartamentos();

        if (!cancelado) {
          setProgresoCarga((prev) => ({
            ...prev,
            departamentos: true,
          }));
        }

      } catch (error) {
        console.error(
          "❌ Error cargando departamentos:",
          error
        );

        errores.push({
          tipo: "departamentos",
          mensaje:
            "No fue posible cargar los departamentos.",
        });
      }

      // ============================================================
      // 2. CARGAR TEMÁTICAS
      // ============================================================

      try {
        await cargarTematicasxSectores();

        if (!cancelado) {
          setProgresoCarga((prev) => ({
            ...prev,
            tematicas: true,
          }));
        }
      } catch (error) {
        console.error(
          "❌ Error cargando temáticas:",
          error
        );

        errores.push({
          tipo: "tematicas",
          mensaje:
            "No fue posible cargar las temáticas.",
        });
      }

      // ============================================================
      // 3. DATOS DEL FORMULARIO
      // ============================================================

      if (
        initialData &&
        Object.keys(initialData).length > 0
      ) {
        setModalVisible(false);
        setIsEditing(true);

        // ----------------------------------------------------------
        // HORAS
        // ----------------------------------------------------------

        const horaInicio =
          typeof initialData.horaInicio === "string"
            ? moment(
                initialData.horaInicio,
                "hh:mm a"
              )
            : null;

        const horaFin =
          typeof initialData.horaFin === "string"
            ? moment(
                initialData.horaFin,
                "hh:mm a"
              )
            : null;

        // ----------------------------------------------------------
        // PRÓXIMA SESIÓN
        // ----------------------------------------------------------

        const proximaSesion =
          initialData.proximaSesion
            ? moment(initialData.proximaSesion)
            : null;

        // ----------------------------------------------------------
        // ACUERDOS
        // ----------------------------------------------------------

        const acuerdos = Array.isArray(
          initialData.acuerdos
        )
          ? initialData.acuerdos.map(
              (acuerdo) => ({
                ...acuerdo,

                fechaLimite:
                  acuerdo?.fechaLimite
                    ? moment(
                        acuerdo.fechaLimite
                      )
                    : null,
              })
            )
          : [];

        // ==========================================================
        // 4. CONSTRUIR VALORES DEL FORMULARIO
        // ==========================================================

        const formValues = {
          ...initialData,
          horaInicio,
          horaFin,
        };

        // ==========================================================
        // IMPORTANTE:
        //
        // NO CONVERTIMOS LAS IMÁGENES A BASE64 AQUÍ.
        //
        // Conservamos directamente las URLs que vienen del backend.
        // ==========================================================

        formValues.fotografia_usuario =
          initialData.fotografia_usuario;

        formValues.fotografias_lugar =
          initialData.fotografias_lugar;

        formValues.fotografia_finalidad =
          initialData.fotografia_finalidad;

        formValues.fotografia_acta =
          initialData.fotografia_acta;

        formValues.fotografia_actividad =
          initialData.fotografia_actividad;

        // ----------------------------------------------------------
        // PRÓXIMA SESIÓN
        // ----------------------------------------------------------

        if (proximaSesion) {
          formValues.proximaSesion =
            proximaSesion;
        }

        // ----------------------------------------------------------
        // ACUERDOS
        // ----------------------------------------------------------

        if (acuerdos.length > 0) {
          formValues.acuerdos =
            acuerdos;
        }

        // ==========================================================
        // 5. CARGAR VALORES AL FORMULARIO
        // ==========================================================

        if (!cancelado) {
          form.setFieldsValue(
            formValues
          );
        }

        // ==========================================================
        // 6. LAS IMÁGENES YA ESTÁN "CARGADAS"
        //
        // No necesitamos descargarlas ni convertirlas.
        // El navegador se encargará de mostrarlas mediante <img>.
        // ==========================================================

        if (!cancelado) {
          setProgresoCarga((prev) => ({
            ...prev,
            imagenes: true,
          }));
        }

      } else {

        // ============================================================
        // FORMULARIO NUEVO
        // ============================================================
        setModalVisible(true);
        setIsEditing(false);

        form.resetFields();

        const fechaActual =
          new Date()
            .toISOString()
            .split("T")[0];

        form.setFieldsValue({
          fecha_registro:
            fechaActual,
        });

        // No hay imágenes que cargar
        if (!cancelado) {
          setProgresoCarga((prev) => ({
            ...prev,
            imagenes: true,
          }));
        }
      }

      // ============================================================
      // 7. RESULTADO GENERAL
      // ============================================================

      if (cancelado) {
        return;
      }

      if (errores.length > 0) {

        console.error(
          "❌ EL FORMULARIO TIENE ERRORES:",
          errores
        );

        setCargaConError(true);
        setErroresCarga(errores);
        setFormLoaded(false);

      } else {
        setCargaConError(false);
        setErroresCarga([]);

        // ========================================================
        // TODO ESTÁ LISTO:
        //
        // Departamentos ✅
        // Temáticas     ✅
        // Datos         ✅
        // URLs imágenes ✅
        // ========================================================

        setFormLoaded(true);
      }

    } catch (error) {

      console.error(
        "❌ ERROR GENERAL CARGANDO FORMULARIO:",
        error
      );

      if (!cancelado) {

        setCargaConError(true);
        setFormLoaded(false);

        setErroresCarga([
          {
            tipo: "general",
            mensaje:
              "Ocurrió un error inesperado al cargar el formulario.",
          },
        ]);
      }

    } finally {
      if (!cancelado) {
        setIsLoadingGeneral(false);
      }
    }
  };

  cargarFormularioCompleto();

  return () => {
    cancelado = true;
  };

}, [
  form,
  obtenerdepartamentos,
  cargarTematicasxSectores,
  initialData,
]);


useEffect(() => {
  if (!isLoadingGeneral && cargaConError && erroresCarga.length > 0) {
    notification.error({
      message: "No se pudo cargar completamente el formulario",
      description: (
        <div>
          {erroresCarga.map((error, index) => (
            <div key={index}>
              • {error.mensaje}
            </div>
          ))}
        </div>
      ),
      duration: 0,
    });
  }
}, [isLoadingGeneral, cargaConError, erroresCarga]);

  const consultarAPI = async (codigo) => {
    //consulta el codigo sirr en la base de datos
    try {
      //consulta el codigo sirr en la base de datos
      const data = await getParticipanteCodigo(codigo);
      if (data.estado) {
        setDatosProyecto(data);
        obtenerUltimaVisitaTecnica(data.oid);
        form.setFieldsValue({ codigoSIRR: codigo });

        //maneja el cambio de estado del departamento
        handleDepartamentoChange(data.departamento);
        form.setFieldsValue({
          nombreProyecto: data.nombre_proyecto,
          departamento: data.departamento,
          municipio: data.municipio,
          codigoPREPP: data.codigo_pre,
          descripcionProyecto: data.descripcion,
          grupoTerritorial: data.grupo_territorial,
          nombreParticipante: data.nombre_if,
          linea_productiva: data.sector,
        });

        // Mostrar mensaje de éxito
        notification.success({
          message: "Consulta Exitosa",
          description: "Datos encontrados y llenados correctamente.",
        });

        setModalVisible(false);
      }
    } catch (error) {
      form.setFieldsValue({ codigoSIRR: "" });

      notification.error({
        message: "Error",
        description: "No se encontraron datos para el código ingresado.",
      });

      setModalVisible(true);
    }
  };

  const handleConsultar = async () => {
    try {
      await consultarAPI(codigoSIRRModal);
      setCodigoSIRRModal("");
    } catch (error) {
      message.error({
        message: "Error",
        description: "No se pudo realizar la consulta. Intente nuevamente.",
      });
    }
  };

  const onFinish = async () => {

    if (!isAllReady) {
      message.warning('Aún hay imágenes cargando o con errores.');
      return;
    }
    setIsLoading(true);
    try {
      // Obtiene los valores actualizados del formulario
      const values = form.getFieldsValue();

      // Formatear horaInicio si es un objeto `moment`
      if (values.horaInicio) {
        values.horaInicio = values.horaInicio.format("hh:mm a");
      }

      // Formatear horaFin si es un objeto `moment`
      if (values.horaFin) {
        values.horaFin = values.horaFin.format("hh:mm a");
      }
      // Formatear proximaSesion si es un objeto `moment`
      if (values.proximaSesion) {
        values.proximaSesion = values.proximaSesion.format("YYYY/MM/DD");
      }
      // Formatear fechas dentro de la lista de acuerdos
      if (Array.isArray(values.acuerdos)) {
        values.acuerdos = values.acuerdos.map((acuerdo) => ({
          ...acuerdo,
          fechaLimite: acuerdo?.fechaLimite
            ? acuerdo.fechaLimite.format("YYYY/MM/DD")
            : null,
        }));
      }

      // Verifica si es edición o inserción y ejecuta la acción correspondiente
      if (isEditing) {
        await actualizarVisitaTecnica(values);
      } else {
        await insertarVisitaTecnica(values);
      }
    } catch (error) {
      console.error("Error al guardar la visita técnica:", error);
    } finally {
      setIsLoading(false); // Asegura que el botón se desbloquee incluso si hay un error
    }
  };

  const base64ToFile = (base64String, index) => {
    const arr = base64String.split(",");
    const mimeMatch = arr[0].match(/:(.*?);/);
    if (!mimeMatch) {
      throw new Error("Formato Base64 incorrecto.");
    }
    const mime = mimeMatch[1];
    const extension = mime.split("/")[1]; // Extraer la extensión del archivo
    const bstr = atob(arr[1]); // Decodificar Base64
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    // Asignar un nombre único usando `Date.now()` y el índice
    const filename = `${Date.now()}-${index}.${extension}`;
    return new File([u8arr], filename, { type: mime });
  };

const envioSoportesVisitaTecnica = async (values, id_registro, initialData = null) => {
  const formData = new FormData();
  formData.append("codigoSir", values.codigoSIRR);
  formData.append("id_visita", id_registro);
  formData.append("usuario_id", usernameFromState.email);

  const imageFields = [
    { key: "firmaProfesionalAsistenteTecnico", type: "firmaProfesionalAsistenteTecnico" },
    { key: "firmaProfesionalAsistenteTecnico_2", type: "firmaProfesionalAsistenteTecnico_2" },
    { key: "firmaTitular", type: "firmaTitular" },
    { key: "fotografia_usuario", type: "fotografia_usuario" },
    { key: "fotografias_lugar", type: "fotografias_lugar" },
    { key: "fotografia_finalidad", type: "fotografia_finalidad" },
    { key: "fotografia_acta", type: "fotografia_acta" },
    { key: "fotografia_actividad", type: "fotografia_actividad" },
  ];

  const sonIguales = (a, b) => {
    if (a === b) return true;
    if (Array.isArray(a) && Array.isArray(b)) {
      if (a.length !== b.length) return false;
      return a.every((item, index) => item === b[index]);
    }
    return false;
  };

  // 🔹 1. Detectar cambios
  let hayCambios = false;
  if (initialData) {
    for (const field of imageFields) {
      const valorActual = values[field.key];
      const valorInicial = initialData[field.key];
      if (!sonIguales(valorActual, valorInicial)) {
        hayCambios = true;
        break;
      }
    }
  } else {
    hayCambios = true;
  }

  if (!hayCambios) {
    return { status: 200, message: "No hay cambios en las imágenes local" };
  }

  // 🔹 2. Procesar campos
  const archivos = [];
  const camposEliminar = [];
  const urlsMantener = {};
  let fileIndex = 1;

  const esBase64 = (valor) => typeof valor === 'string' && valor.startsWith('data:image');
  const esUrl = (valor) => typeof valor === 'string' && (valor.startsWith('/') || valor.startsWith('http'));
  const estaVacio = (valor) => {
    if (valor === null || valor === undefined) return true;
    if (Array.isArray(valor)) return valor.length === 0;
    if (typeof valor === 'string') return valor.trim() === '';
    return false;
  };

  imageFields.forEach((field) => {
    const valorActual = values[field.key];
    const valorInicial = initialData ? initialData[field.key] : null;

    // Si el campo está vacío y antes tenía valor → marcamos para eliminar
    if (estaVacio(valorActual)) {
      if (initialData && !estaVacio(valorInicial)) {
        camposEliminar.push(field.type);
      }
      return;
    }

    // Si es un array
    if (Array.isArray(valorActual)) {
      const urls = [];
      valorActual.forEach((item) => {
        if (!item || item.trim() === '') return;
        if (esBase64(item)) {
          try {
            const file = base64ToFile(item, fileIndex, field.type);
            archivos.push({ file, type: field.type });
            fileIndex++;
          } catch (error) {
            console.error(`❌ Error al procesar base64 en ${field.key}:`, error);
          }
        } else if (esUrl(item)) {
          urls.push(item);
        }
      });
      if (urls.length > 0) {
        urlsMantener[field.type] = urls;
      }
    } else {
      // Valor string
      const valor = valorActual.trim();
      if (esBase64(valor)) {
        try {
          const file = base64ToFile(valor, fileIndex, field.type);
          archivos.push({ file, type: field.type });
          fileIndex++;
        } catch (error) {
          console.error(`❌ Error al procesar ${field.key}:`, error);
        }
      } else if (esUrl(valor)) {
        urlsMantener[field.type] = [valor];
      }
    }
  });

  // 🔹 3. Construir formData
  if (camposEliminar.length > 0) {
    formData.append("camposEliminar", JSON.stringify(camposEliminar));
  }

  if (Object.keys(urlsMantener).length > 0) {
    formData.append("urlsMantener", JSON.stringify(urlsMantener));
  }

  if (archivos.length > 0) {
    const typeFileArrayOrdenado = archivos.map((item) => item.type);
    formData.append("typeFile", JSON.stringify(typeFileArrayOrdenado));
    archivos.forEach(({ file }) => {
      formData.append("imagenes", file);
    });
  }

  // Si no hay nada que enviar (pero hay cambios detectados, no debería ocurrir)
  if (archivos.length === 0 && camposEliminar.length === 0 && Object.keys(urlsMantener).length === 0) {
    return { status: 200, message: "No hay cambios en las imágenes" };
  }

  try {
    if (isEditing) {
      return await updateSoportesVisitaTecnica(formData);
    } else {
      return await uploadSoportesVisitaTecnica(formData);
    }
  } catch (error) {
    console.error("❌ Error al subir archivos:", error.response?.data || error);
    return { status: 500, message: "Error al subir archivos" };
  }
};

const insertarVisitaTecnica = async (values) => {
  const clavesImagenes = [
    "firmaProfesionalAsistenteTecnico",
    "firmaProfesionalAsistenteTecnico_2",
    "firmaTitular",
    "fotografia_usuario",
    "fotografias_lugar",
    "fotografia_finalidad",
    "fotografia_acta",
    "fotografia_actividad",
  ];

  // =====================================================
  // FILTRAR IMÁGENES DEL DETALLE
  // =====================================================

  const valoresFiltrados = Object.fromEntries(
    Object.entries(values).filter(
      ([key]) => !clavesImagenes.includes(key)
    )
  );

  try {
    // =====================================================
    // 1. PREPARAR DATA DE LA VISITA
    // =====================================================

    const baseData = {
      ...valoresFiltrados,
      fuente: "Web",
      user_email: usernameFromState.email,
    };

    const data = {
      detalle: baseData,
      numero_visita: ultima_visita,
      id_participante: datosProyecto.oid,
      tipo_envio: "Envio",
    };

    // =====================================================
    // 2. INSERTAR VISITA
    // =====================================================

    const result = await insertVisitaTecnica(data);

    if (result.status !== 200) {
      notification.error({
        message: "Error",
        description:
          result.message ||
          "No se pudo registrar la visita técnica.",
      });

      return;
    }

    const oid = result.id;
    // =====================================================
    // 3. DETERMINAR SI HAY IMÁGENES
    // =====================================================

    const tieneImagenes = clavesImagenes.some((key) => {
      const valor = values[key];

      if (!valor) {
        return false;
      }

      // Si es un array
      if (Array.isArray(valor)) {
        return valor.length > 0;
      }

      // Si es un string/base64/URL
      if (typeof valor === "string") {
        return valor.trim() !== "";
      }

      return false;
    });
    // =====================================================
    // 4. SI HAY IMÁGENES, GUARDARLAS
    // =====================================================

    if (tieneImagenes) {
      let soportesCorrectos = false;

      try {
        const respuesta =
          await envioSoportesVisitaTecnica(
            values,
            oid
          );

        /*
         * Consideramos exitoso únicamente cuando:
         *
         * respuesta existe
         * no es false
         * status === 200
         */

        soportesCorrectos =
          respuesta &&
          respuesta !== false &&
          respuesta.status === 200;

      } catch (error) {
        console.error(
          "Error inesperado enviando imágenes:",
          error
        );

        soportesCorrectos = false;
      }

      // ===================================================
      // 5. SI FALLAN LAS IMÁGENES → ELIMINAR VISITA
      // ===================================================

      if (!soportesCorrectos) {
        console.error(
          "Falló la inserción de imágenes. Eliminando visita:",
          oid
        );

        try {
          const resp =
            await deleteVisitaTecnica(oid);

          if (resp.success) {
            message.success(
              "La visita fue eliminada porque no se pudieron guardar correctamente las imágenes."
            );
          } else {
            message.error(
              "No se pudieron guardar las imágenes y tampoco se pudo eliminar la visita técnica."
            );
          }

        } catch (error) {
          console.error(
            "Error eliminando la visita técnica:",
            error
          );

          message.error(
            "No se pudieron guardar las imágenes y no se pudo eliminar la visita técnica."
          );
        }

        // IMPORTANTE:
        // No generar PDF
        return;
      }
    } else {
      console.log(
        "La visita no tiene imágenes. Se continuará directamente con el PDF."
      );
    }

    // =====================================================
    // 6. GENERAR PDF
    // =====================================================

    let respuestaPDF;

    try {
      respuestaPDF =
        await enviarPDFAlServidor(oid);
    } catch (error) {
      console.error(
        "Error generando/enviando PDF:",
        error
      );

      notification.error({
        message: "Error al subir PDF",
        description:
          "La visita se guardó correctamente, pero ocurrió un problema al generar o subir el PDF.",
      });

      return;
    }

    // =====================================================
    // 7. VALIDAR RESPUESTA DEL PDF
    // =====================================================

    if (
      !respuestaPDF ||
      respuestaPDF.status !== 200
    ) {
      notification.error({
        message: "Error al subir PDF",
        description:
          "La visita se guardó correctamente, pero hubo un problema al generar o subir el archivo PDF.",
      });

      return;
    }

    // =====================================================
    // 8. TODO CORRECTO
    // =====================================================
    notification.success({
      message: "Éxito",
      description: tieneImagenes
        ? "Visita técnica guardada correctamente con registros fotográficos y PDF."
        : "Visita técnica guardada correctamente y PDF generado.",
    });

    onClose();
    fetchData();

  } catch (error) {
    console.error(
      "Error general al guardar la visita técnica:",
      error
    );

    notification.error({
      message: "Error",
      description:
        "No se pudo guardar la visita técnica.",
    });
  }
};

// Función para actualizar una visita técnica existente
const actualizarVisitaTecnica = async (values) => {
  const clavesImagenes = [
    "firmaProfesionalAsistenteTecnico",
    "firmaProfesionalAsistenteTecnico_2",
    "firmaTitular",
    "fotografia_usuario",
    "fotografias_lugar",
    "fotografia_finalidad",
    "fotografia_acta",
    "fotografia_actividad",
  ];

  // =====================================================
  // FILTRAR IMÁGENES DEL DETALLE
  // =====================================================

  const valoresFiltrados = Object.fromEntries(
    Object.entries(values).filter(
      ([key]) => !clavesImagenes.includes(key)
    )
  );

  try {
    // =====================================================
    // 1. ACTUALIZAR DATOS DE LA VISITA
    // =====================================================

    const data = {
      ...valoresFiltrados,
      fuente: initialData.fuente,
      user_email: initialData.user_email,
    };

    const result = await updateVisitaTecnica(
      initialData.id,
      data,
      usernameFromState.email
    );

    // Si falla la actualización de datos,
    // no continuar con imágenes ni PDF
    if (result.status !== 200) {
      notification.error({
        message: "Error",
        description:
          result.message ||
          "No se pudo actualizar la visita técnica.",
      });

      return;
    }

    // =====================================================
    // 2. DETERMINAR SI HAY IMÁGENES
    // =====================================================

    const tieneImagenes = clavesImagenes.some((key) => {
      const valor = values[key];

      if (!valor) {
        return false;
      }

      if (Array.isArray(valor)) {
        return valor.length > 0;
      }

      if (typeof valor === "string") {
        return valor.trim() !== "";
      }

      return false;
    });

    // Variable para saber si las imágenes fallaron
    let imagenesCorrectas = true;

    // =====================================================
    // 3. ENVIAR IMÁGENES
    // =====================================================

    if (tieneImagenes) {
      try {
        const respuestaSoportes =
          await envioSoportesVisitaTecnica(
            values,
            initialData.id,
            initialData
          );

        // Validar respuesta
        if (
          !respuestaSoportes ||
          respuestaSoportes === false ||
          respuestaSoportes.status !== 200
        ) {
          imagenesCorrectas = false;
        }

      } catch (error) {
        console.error(
          "Error enviando imágenes:",
          error
        );

        imagenesCorrectas = false;
      }
    }

    // =====================================================
    // 4. INFORMAR SI LAS IMÁGENES FALLARON
    // =====================================================

    if (!imagenesCorrectas) {
      notification.warning({
        message: "Imágenes no cargadas",
        description:
          "Los datos de la visita fueron actualizados correctamente, pero algunas imágenes no pudieron cargarse. La ventana permanecerá abierta para que pueda intentar nuevamente.",
      });
    }

    // =====================================================
    // 5. GENERAR PDF
    //
    // IMPORTANTE:
    // Aunque las imágenes fallen, el PDF SÍ se genera.
    // ====================================================
    let respuestaPDF;

    try {
      respuestaPDF = await enviarPDFAlServidor(
        initialData.id
      );
    } catch (error) {
      console.error(
        "Error generando/enviando PDF:",
        error
      );

      notification.error({
        message: "Error al subir PDF",
        description:
          imagenesCorrectas
            ? "Los datos fueron actualizados, pero ocurrió un problema al generar o subir el PDF."
            : "Los datos fueron actualizados, pero las imágenes no se cargaron y además ocurrió un problema al generar o subir el PDF.",
      });

      // No cerrar modal
      return;
    }

    // =====================================================
    // 6. VALIDAR PDF
    // =====================================================

    if (
      !respuestaPDF ||
      respuestaPDF.status !== 200
    ) {
      notification.error({
        message: "Error al subir PDF",
        description:
          imagenesCorrectas
            ? "La visita se actualizó correctamente, pero hubo un problema al generar o subir el PDF."
            : "La visita se actualizó correctamente, pero falló la carga de las imágenes y también hubo un problema con el PDF.",
      });

      // No cerrar modal
      return;
    }

    // =====================================================
    // 7. RESULTADO FINAL
    // =====================================================

    if (!imagenesCorrectas) {
      // Los datos y PDF están correctos,
      // pero las imágenes fallaron.
      notification.warning({
        message: "Actualización parcial",
        description:
          "La visita técnica y el PDF fueron actualizados correctamente, pero las imágenes no pudieron cargarse. Puede intentar subirlas nuevamente.",
      });

      // IMPORTANTE:
      // NO cerrar modal
      fetchData();

      return;
    }

    // =====================================================
    // 8. TODO CORRECTO
    // =====================================================

    notification.success({
      message: "Éxito",
      description:
        "Visita técnica actualizada correctamente.",
    });

         // Cerrar modal y refrescar datos después de un breve delay
      setTimeout(() => {
        onClose();
        fetchData();
      }, 300);

  } catch (error) {
    console.error(
      "Error inesperado:",
      error
    );

    notification.error({
      message: "Error",
      description:
        "Ocurrió un error inesperado al actualizar la visita técnica.",
    });
  }
};

  const fetchVisitaTecnicaById_pdf = async (id) => {
    try {
      const response = await getVisitaTecnicaById(id);
      const { status, data } = response;

      if (status) {
        return data;
      } else {
        return null;
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "An error occurred while fetching data.",
      });
    }
  };

  const enviarPDFAlServidor = async (id) => {
    try {
      let data = await fetchVisitaTecnicaById_pdf(id);
      const { detalle, ...restoData } = data;

      const datosCompletos = {
        ...detalle,
        ...restoData,
      };

      let blob = await pdf(
        <PdfAlmacenarVisitaTecnica formData={datosCompletos} />
      ).toBlob();
      const fechaArchivo = datosCompletos.fecha_registro.replace(/-/g, "_");
      const nombreArchivo = `1_Visita_${data.numero_visita}_${fechaArchivo}.pdf`;

      const formDataToSend = new FormData();
      formDataToSend.append(
        "ruta",
        `${data.fecha_directorio}/${data.departamento_p}/${data.codigo_pre}/`
      );
      formDataToSend.append("ruta_anterior", `${data.ruta_pdf}`);
      formDataToSend.append("nombre_archivo", nombreArchivo);
      formDataToSend.append("file", blob, nombreArchivo);

      const response = await postSoporteVisitaTecnicaPatti(
        formDataToSend,
        data.id
      );
      return response;
    } catch (err) {
      console.error("❌ Error al enviar el PDF:", err);
    }
  };


const formularioBloqueado =
  isLoadingGeneral ||
  cargaConError ||
  !formLoaded;

  const isAllReady = allImagesReady();
  const hayCarga = Object.values(loadingStatus).some(v => v === true);
  const hayError = Object.values(readyStatus).some(v => v === false);

  return (
    <div className="form-container">
      <Card className="form-card">
        <Title level={2} className="main-title-subtitule">
          Visita Técnica
        </Title>
            {!isLoadingGeneral &&
      cargaConError &&
      erroresCarga.length > 0 && (
        <Alert
          type="error"
          showIcon
          message="No se pudo cargar completamente el formulario"
          description={
            <div>
              {erroresCarga.map((error, index) => (
                <div key={index}>
                  • {error.mensaje}
                </div>
              ))}
            </div>
          }
          style={{
            marginBottom: 16,
          }}
        />
      )}
       <div
  style={{
    position: "relative",
    minHeight: 300,
  }}
>
  {isLoadingGeneral && (
    <div
      style={{
        position: "absolute",
        inset: 0,
        zIndex: 1000,
        background: "rgba(255, 255, 255, 0.95)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        borderRadius: 8,
      }}
    >
      <Spin size="large" />

      <div
        style={{
          marginTop: 20,
          fontSize: 17,
          fontWeight: 500,
        }}
      >
        Cargando formulario...
      </div>

      <div
        style={{
          marginTop: 15,
          fontSize: 14,
          lineHeight: "28px",
        }}
      >
        <div>
          {progresoCarga.departamentos
            ? "✅"
            : "⏳"}{" "}
          Departamentos
        </div>

        <div>
          {progresoCarga.tematicas
            ? "✅"
            : "⏳"}{" "}
          Temáticas
        </div>

        <div>
          {progresoCarga.imagenes
            ? "✅"
            : "⏳"}{" "}
          Imágenes
        </div>
      </div>
    </div>
  )}
        <Form form={form} 
              onFinish={onFinish}       
              onValuesChange={onValuesChange}
              disabled={formularioBloqueado}
              layout="vertical">

          <Row gutter={[16, 16]}>
            <Col xs={24} sm={6}>
              <Form.Item
                label="Fecha de Registro (AAAA-MM-DD)"
                name="fecha_registro"
              >
                <Input
                  disabled={
                    usernameFromState?.username !== "admin" &&
                    usernameFromState?.username !== "Liliana"
                  }
                />              
            </Form.Item>
            </Col>

            <Col xs={24} sm={6}>
              <Form.Item label="Numero de la visita" name="numero_visita">
                <Input disabled={
                    usernameFromState?.username !== "admin" &&
                    usernameFromState?.username !== "Liliana"
                  }
                  />
              </Form.Item>
            </Col>

            <Col xs={24} sm={6}>
              <Form.Item label="Departamento" name="departamento">
                <Select onChange={handleDepartamentoChange}>
                  {departamentos.map((depto) => (
                    <Option key={depto.id} value={depto.nombre}>
                      {depto.nombre}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={6}>
              <Form.Item label="Municipio" name="municipio">
                <Select>
                  {municipios.map((mun) => (
                    <Option
                      key={mun.nombre_municipio}
                      value={mun.nombre_municipio}
                    >
                      {mun.nombre_municipio}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={24}>
              <Title level={4}>
                Selecione los tipos de capacitación de la visita
              </Title>
              <Form.List name="lista_capacitaciones">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(
                      ({ key, name, fieldKey, ...restField }, index) => (
                        <Space
                          key={key}
                          align="baseline"
                          className="block-display-important"
                          style={{ marginTop: 20 }}
                        >
                          <Row gutter={[16, 16]} key={key}>
                            <Col xs={24} sm={5}>
                              <Form.Item
                                {...restField}
                                label="Temática"
                                name={[name, "tema"]}
                                fieldKey={[fieldKey, "tema"]}
                                rules={[
                                  {
                                    required: true,
                                    message:
                                      "Por favor seleccione una temática",
                                  },
                                ]}
                              >
                                <Select
                                  showSearch
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                  onChange={(option, value) => {
                                    handleTemaChange(
                                      option,
                                      value,
                                      index,
                                      name
                                    ); // Actualiza áreas filtradas
                                  }}
                                >
                                  {dataTematicasxFactores ? (
                                    dataTematicasxFactores.temas &&
                                    dataTematicasxFactores.temas.length > 0 ? (
                                      dataTematicasxFactores.temas.map(
                                        (tema) => (
                                          <Option
                                            key={tema.id}
                                            value={tema.tema}
                                          >
                                            {tema.tema}
                                          </Option>
                                        )
                                      )
                                    ) : (
                                      <Option disabled value="">
                                        No hay áreas temáticas disponibles
                                      </Option>
                                    )
                                  ) : (
                                    <Option disabled value="">
                                      Cargando áreas temáticas...
                                    </Option>
                                  )}
                                </Select>
                              </Form.Item>
                            </Col>

                            <Col xs={24} sm={4}>
                              <Form.Item
                                {...restField}
                                label="Fortalecimiento"
                                name={[name, "area"]}
                                fieldKey={[fieldKey, "area"]}
                                rules={[
                                  {
                                    required: true,
                                    message:
                                      "Por favor seleccione un fortalecimiento",
                                  },
                                ]}
                              >
                                <Select
                                  showSearch
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                  onChange={(option, value) => {
                                    handleAreaTematicaChange(
                                      option,
                                      value,
                                      index
                                    ); // Actualiza áreas filtradas
                                  }}
                                >
                                  {areasFiltradas ? (
                                    areasFiltradas.length > 0 ? (
                                      areasFiltradas.map((area) => (
                                        <Option
                                          key={area.id}
                                          value={area.areaTematica}
                                        >
                                          {area.areaTematica}
                                        </Option>
                                      ))
                                    ) : (
                                      <Option disabled value="">
                                        No hay áreas temáticas disponibles
                                      </Option>
                                    )
                                  ) : (
                                    <Option disabled value="">
                                      Cargando áreas temáticas...
                                    </Option>
                                  )}
                                </Select>
                              </Form.Item>
                            </Col>

                            <Col xs={24} sm={6}>
                              <Form.Item
                                {...restField}
                                label="Capacitación"
                                name={[name, "tematica"]}
                                fieldKey={[fieldKey, "tematica"]}
                                rules={[
                                  {
                                    required: true,
                                    message:
                                      "Por favor seleccione una capacitación",
                                  },
                                ]}
                              >
                                <Select
                                  showSearch
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                  onChange={(option, value) => {
                                    handleTematicaChange(option, value, name); // Actualiza áreas filtradas
                                  }}
                                >
                                  {tematicasFiltradas ? (
                                    tematicasFiltradas.length > 0 ? (
                                      tematicasFiltradas.map((tema) => (
                                        <Option
                                          key={tema.id}
                                          value={tema.tematica}
                                        >
                                          {tema.tematica}
                                        </Option>
                                      ))
                                    ) : (
                                      <Option disabled value="">
                                        No hay temáticas disponibles
                                      </Option>
                                    )
                                  ) : (
                                    <Option disabled value="">
                                      Cargando temáticas...
                                    </Option>
                                  )}
                                </Select>
                              </Form.Item>
                            </Col>

                            <Col xs={24} sm={8}>
                              <Form.Item
                                {...restField}
                                label="Factor"
                                name={[name, "factor"]}
                                fieldKey={[fieldKey, "factor"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Por favor seleccione un factor",
                                  },
                                ]}
                              >
                                <TextArea rows={2} disabled={true}></TextArea>
                              </Form.Item>
                            </Col>

                            <Col
                              xs={24}
                              sm={1}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                              }}
                            >
                              <Popconfirm
                                title="¿Está seguro de eliminarlo?"
                                okText="Sí"
                                cancelText="No"
                                onConfirm={() => remove(name)}
                              >
                                <MinusCircleOutlined />
                              </Popconfirm>
                            </Col>
                          </Row>
                        </Space>
                      )
                    )}
                    <Form.Item>
                      <Button
                        type="dashed"
                        onClick={() => {
                          actualizarselectores();
                          add(); // Agrega un nuevo conjunto de campos
                        }}
                        block
                      >
                        Agregar
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item label="Vereda" name="vereda">
                <Input />
              </Form.Item>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item label="Grupo territorial" name="grupoTerritorial">
                <Input type="text" disabled />
              </Form.Item>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item label="Código PRE-PP" name="codigoPREPP">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item label="Nombre Del Proyecto" name="nombreProyecto">
                <Input disabled />
              </Form.Item>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item
                label="Quien recibe la visita"
                name="quienRecibeVisita"
              >
                <Select>
                  <Option value="Titular del proyecto">
                    Titular del proyecto
                  </Option>
                  <Option value="Tercero autorizado">Tercero autorizado</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item label="Nombre del Titular" name="nombreParticipante">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item
                label="Número de identificación"
                name="numeroIdentificacion"
              >
                <Input type="number" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item label="Código -SIRR" name="codigoSIRR">
                <Input value={codigoSIRR} disabled />
              </Form.Item>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item
                label="Numero de personas que participan"
                name="numeroPersonasParticipan"
                rules={[
                  { required: true, message: "Por favor seleciona una opción" },
                ]}
              >
                <Select>
                  <Option value={1}>1</Option>
                  <Option value={2}>2</Option>
                  <Option value={3}>3</Option>
                  <Option value={4}>4</Option>
                  <Option value={5}>5</Option>
                  <Option value="+DE 5">+DE 5</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item label="Número de Hombres" name="numeroHombres">
                <Input type="number" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item label="Número de Mujeres" name="numeroMujeres">
                <Input type="number" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item
                label="Hora de Inicio"
                name="horaInicio"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingresa la hora de inicio",
                  },
                ]}
              >
                <TimePicker format="hh:mm a" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item
                label="Hora de Finalización"
                name="horaFin"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingresa la hora de fin",
                  },
                ]}
              >
                <TimePicker format="hh:mm a" />
              </Form.Item>
            </Col>
          </Row>

          <Title level={4}>PUNTO DE GEOREFERENCIA</Title>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              {/* Botón de ubicación */}
              <Button
                icon={<AimOutlined />}
                onClick={handleLocateClick}
                style={{ marginBottom: "16px" }}
              >
                Usar mi ubicación
              </Button>
              {/* Mapa - Aumentando el tamaño */}
              <div
                style={{ height: "300px", width: "100%", marginBottom: "16px" }}
              >
                <MapContainer
                  center={markerPosition}
                  zoom={13}
                  style={{ height: "100%", width: "100%" }}
                  ref={mapRef}
                >
                  <LayersControl position="topright">
                    <BaseLayer checked name="OpenStreetMap">
                      <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                      />
                    </BaseLayer>
                    <BaseLayer name="OpenTopoMap">
                      <TileLayer
                        url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="https://opentopomap.org">OpenTopoMap</a> contributors'
                      />
                    </BaseLayer>
                    <BaseLayer name="OpenStreetMap H.O.T.">
                      <TileLayer
                        url="https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                      />
                    </BaseLayer>
                  </LayersControl>
                  <LocationMarker />
                </MapContainer>
              </div>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item
                name="latuser"
                label="Latitud"
                rules={[
                  { required: true, message: "La latitud es obligatoria" },
                ]}
              >
                <Input placeholder="Latitud" value={latitude} />
              </Form.Item>

              <Form.Item
                name="lnguser"
                label="Longitud"
                rules={[
                  { required: true, message: "La longitud es obligatoria" },
                ]}
              >
                <Input placeholder="Longitud" value={longitude} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Linea productiva del proyecto"
                name="linea_productiva"
              >
                <Select
                  disabled={true}
                  placeholder="Seleccionar"
                  onChange={(value) => {
                    setIsOtra(value === "Otra"); // Cambia el estado si se selecciona "Otra"
                    if (value !== "Otra") {
                      form.setFieldsValue({ otra_linea_productiva: "" }); // Limpiar el campo si no es "Otra"
                    }
                  }}
                >
                  <Option value="Agrícola">Agrícola</Option>
                  <Option value="Pecuaria">Pecuaria</Option>
                  <Option value="Servicios">Servicios</Option>
                  <Option value="Comercial">Comercial</Option>
                  <Option value="Industrial">Industrial</Option>
                  <Option value="Otra">Otra</Option>
                </Select>
              </Form.Item>
            </Col>
            {isOtra && ( // Muestra el campo adicional solo si isOtra es verdadero
              <Col xs={24} sm={12}>
                <Form.Item
                  label="Especificar otra línea productiva"
                  name="otra_linea_productiva"
                >
                  <Input placeholder="Especificar" />
                </Form.Item>
              </Col>
            )}
          </Row>

          <Title level={4}>ASPECTOS METODOLÓGICOS</Title>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Modalidad de sesión capacitación"
                name="modalidad_sesion_capacitacion"
                rules={[
                  {
                    required: true,
                    message: "Por favor seleccione una modalidad se seción",
                  },
                ]}
              >
                <Select
                  placeholder="Seleccionar"
                  onChange={(value) => {
                    setModalidadSesionCapacitacion(value === "Otro"); // Cambia el estado si se selecciona "Otra"
                    if (value !== "Otro") {
                      form.setFieldsValue({
                        otra_modalidad_sesion_capacitacion: "",
                      }); // Limpiar el campo si no es "Otra"
                    }
                  }}
                >
                  <Option value="Visita técnica">Visita técnica</Option>
                  <Option value="Estrategia asincronica">
                    Estrategia asincronica
                  </Option>
                  <Option value="Espacios grupales">Espacios grupales</Option>
                  <Option value="Otro">Otro</Option>
                </Select>
              </Form.Item>
            </Col>
            {modalidadSesionCapacitacion && ( // Muestra el campo adicional solo si isOtra es verdadero
              <Col xs={24} sm={12}>
                <Form.Item
                  label="Especificar otra modalidad de sesión capacitación"
                  name="otra_modalidad_sesion_capacitacion"
                >
                  <Input placeholder="Especificar" />
                </Form.Item>
              </Col>
            )}
          </Row>

          <Title level={4}>ACTIVIDADES DESARROLLADAS EN LA VISITA</Title>
          <Row gutter={16}>
            <Col xs={24} sm={24}>
              <Form.Item
                label="En este apartado se debe describir las actividades desarrolladas de acuerdo al factor y la tematica seleccionada al inicio de la jornada.. Temas aborados y que han sido seleccionados desde el analisis de capacidades"
                name="actividadesDesarrolladas"
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
          </Row>

          <Title level={4}>
            AVANCE DE ACTIVIDADES POR FACTORES DE SOSTENIBILIDAD
          </Title>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Avance de actividades Factor 1. Acompañamiento y fortalecimiento técnico y financiero"
                name="avanceFactor1"
              >
                <Input.TextArea
                  rows={4}
                  placeholder="Recomendaciones brindadas por tema y resultados de avance (analisis de la situacion con la que encontre inicialmnete la unidad de negocio y como lo veo actualmente) Tener en cuenta las diferentes cariables del proyecto."
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Avance de actividades Factor 2. Fortalecimiento organizativo y asociativo"
                name="avanceFactor2"
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Avance de Actividades: Factor 3. Acompañamiento y fortalecimiento a procesos de mercadeo y comercialización"
                name="avanceFactor3"
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Avance de actividades Factor 4. Acompañamiento y gestión para la articulación e incidencia territorial"
                name="avanceFactor4"
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Avance de actividades Factor 5. Acompañamiento para la Implementación de los enfoques diferenciales"
                name="avanceFactor5"
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Avance de actividades Factor 6. Generación de condiciones para el acceso a tierra"
                name="avanceFactor6"
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Avance de actividades Factor 7. Promoción de la articulación interinstitucional para la seguridad humana en los territorios"
                name="avanceFactor7"
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Avance de actividades Factor 8. Acompañamiento para la implementación de los planes/programas de manejo ambiental (PMA) y el fortalecimiento de relaciones sostenibles entre seres humanos y otras formas de vida"
                name="avanceFactor8"
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item label="Próxima Sesión" name="proximaSesion">
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item label="Modalidad" name="modalidad">
                <Select>
                  <Option value="Presencial">Presencial</Option>
                  <Option value="Virtual">Virtual</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Title level={4}>HALLAZGOS</Title>
          <Row gutter={16}>
            <Col xs={24} sm={24}>
              <Form.Item
                label="Incluir situaciones encontradas como dificultades o particularidades de las intervenciones realizadas de cualquier índole, con el fin de dejar trazabilidad de todo el proceso. Reportar posibles alertas tempranas en el presente documento con el fin de dejar la trazabilidad respectiva, así como las alternativas analizadas entre todas las partes. Reportar, si aplica, posibles casos de éxito del proyecto productivo o información relacionada que sirva a la contextualización del proceso de asistencia técnica."
                name="hallazgos"
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
          </Row>

          <Title level={4}>RECOMENDACIONES</Title>
          <Row gutter={16}>
            <Col xs={24} sm={24}>
              <Form.Item name="recomendaciones">
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
          </Row>

          <Title level={4}>ACUERDOS</Title>
          <Form.List name="acuerdos">
            {(fields, { add, remove }) => (
              <>
                <Row gutter={16}>
                  <Col xs={8}>
                    <strong>Compromiso</strong>
                  </Col>
                  <Col xs={8}>
                    <strong>Responsable</strong>
                  </Col>
                  <Col xs={7}>
                    <strong>Fecha Límite</strong>
                  </Col>
                  <Col xs={1}></Col>
                </Row>
                {fields.map(({ key, name, fieldKey, ...restField }) => (
                  <Row gutter={16} key={key} style={{ marginTop: "10px" }}>
                    <Col xs={8}>
                      <Form.Item
                        {...restField}
                        name={[name, "compromiso"]}
                        fieldKey={[fieldKey, "compromiso"]}
                      >
                        <Input placeholder="Compromiso" />
                      </Form.Item>
                    </Col>
                    <Col xs={8}>
                      <Form.Item
                        {...restField}
                        name={[name, "responsable"]}
                        fieldKey={[fieldKey, "responsable"]}
                      >
                        <Input placeholder="Responsable" />
                      </Form.Item>
                    </Col>
                    <Col xs={7}>
                      <Form.Item
                        {...restField}
                        name={[name, "fechaLimite"]}
                        fieldKey={[fieldKey, "fechaLimite"]}
                      >
                        <DatePicker
                          placeholder="Fecha Límite"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={1}>
                      <Popconfirm
                        title="¿Está seguro de que desea eliminar este acuerdo?"
                        onConfirm={() => remove(name)}
                        okText="Sí"
                        cancelText="No"
                      >
                        <Button
                          type="link"
                          icon={<DeleteOutlined style={{ color: "red" }} />}
                        />
                      </Popconfirm>
                    </Col>
                  </Row>
                ))}
                <Form.Item>
                  <Button type="dashed" onClick={() => add()} block>
                    Agregar Acuerdo
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
          <Title level={4}>FIRMA ELECTRÓNICA</Title>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Firma profesional asistente técnico"
                name="firmaProfesionalAsistenteTecnico"
              >
                <FirmaCanvas
                  label="Firma profesional asistente técnico"
                  name="firmaProfesionalAsistenteTecnico"
                  form={form}
                  formLoaded={formLoaded}
                  modoFirma= "url"
                />
              </Form.Item>

              <Form.Item
                label="Nombre profesional asistencia técnica"
                name="nombreProfesionalAsistenteTecnico"
              >
                <Input type="text" />
              </Form.Item>
              <Form.Item label="Cedula" name="ccProfesionalAsistenteTecnico">
                <Input type="number" />
              </Form.Item>

              <Form.Item
                label="Profesión"
                name="ProfesionProfesionalAsistenteTecnico"
              >
                <Input type="text" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item
                label="Firma profesional asistente técnico 2"
                name="firmaProfesionalAsistenteTecnico_2"
              >
                <FirmaCanvas
                  label="Firma profesional asistente técnico 2"
                  name="firmaProfesionalAsistenteTecnico_2"
                  form={form}
                  formLoaded={formLoaded}
                  modoFirma= "url"
                />
              </Form.Item>

              <Form.Item
                label="Nombre profesional asistente tecnico 2"
                name="nombreProfesionalAsistenteTecnico_2"
              >
                <Input type="text" />
              </Form.Item>
              <Form.Item label="Cedula" name="ccProfesionalAsistenteTecnico_2">
                <Input type="number" />
              </Form.Item>

              <Form.Item
                label="Profesión"
                name="ProfesionProfesionalAsistenteTecnico_2"
              >
                <Input type="text" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item label="Firma del titular" name="firmaTitular">
                <FirmaCanvas
                  label="Firma del titular"
                  name="firmaTitular"
                  form={form}
                  formLoaded={formLoaded}
                  modoFirma= "url"
                />
              </Form.Item>
              <Form.Item
                label="Nombre del titular o tercero autorizado"
                name="nombreTitular"
              >
                <Input type="text" />
              </Form.Item>
              <Form.Item label="Cedula" name="ccTitular">
                <Input type="number" />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item name="fotografia_usuario">
            <ImagenUploader
              titulo="FOTOGRAFÍA (BUENA DEFINICIÓN) CON EL USUARIO"
              onChange={handleFotografiaUsuarioChange}
              value={initialData?.fotografia_usuario}
              onLoadingChange={handleLoadingChange}
              onStatusChange={handleStatusChange}  // <-- NUEVA PROP
              name="fotografia_usuario"   // <--- AGREGAR

            />
          </Form.Item>

          <Form.Item name="fotografias_lugar">
            <ImagenUploader
              titulo="FOTOGRAFÍA  (BUENA DEFINICIÓN) EN EL LUGAR DONDE SE DESARROLLA EL PROYECTO PRODUCTIVO"
              onChange={handleFotografiasLugarChange}
              value={initialData?.fotografias_lugar}
              onLoadingChange={handleLoadingChange}
              onStatusChange={handleStatusChange}
              name="fotografias_lugar"
            />
          </Form.Item>

          <Form.Item name="fotografia_finalidad">
            <ImagenUploader
              titulo="FOTOGRAFÍA  (BUENA DEFINICIÓN), QUE REPRESENTE LA FINALIDAD DEL PROYECTO PRODUCTIVO"
              onChange={handleFotografiaFinalidadChange}
              value={initialData?.fotografia_finalidad}
              onLoadingChange={handleLoadingChange}
              onStatusChange={handleStatusChange}
              name="fotografia_finalidad"
            />
          </Form.Item>

          <Form.Item name="fotografia_acta">
            <ImagenUploader
              titulo="FOTOGRAFÍA (BUENA DEFINICIÓN) CON EL USUARIO DILIGENCIANDO EL ACTA DE LA VISITA"
              onChange={handleFotografiaActaChange}
              value={initialData?.fotografia_acta}
              onLoadingChange={handleLoadingChange}
              onStatusChange={handleStatusChange}
              name="fotografia_acta"
            />
          </Form.Item>
          <Form.Item name="fotografia_actividad">
            <ImagenUploader
              titulo="FOTOGRAFÍA (BUENA DEFINICIÓN) DONDE SE EVIDENCIE UNA ACTIVIDAD PROPIA DEL PROYECTO PRODUCTIVO"
              onChange={handleFotografiaActividadChange}
              value={initialData?.fotografia_actividad}
              onLoadingChange={handleLoadingChange}
              onStatusChange={handleStatusChange}
              name="fotografia_actividad"
            />
          </Form.Item>

          <div style={{ textAlign: "center", marginTop: "40px" }}>
            {/* Ocultar o deshabilitar el botón de consultar si está en edición */}

            <Button
              type="primary"
              htmlType="submit"
              style={{
                backgroundColor: isAllReady ? "#52c41a" : "#d9d9d9",
                borderColor: isAllReady ? "#52c41a" : "#d9d9d9",
              }}
              loading={isLoading}
              disabled={!isDirty || !isAllReady}
            >
              {isEditing ? "Actualizar Visita Técnica" : "Guardar Visita Técnica"}
            </Button>

                {/* Mensaje de estado */}
                {!isAllReady && (
                  <div style={{ marginTop: 16, color: '#cf1322', fontSize: 14 }}>
                    {hayCarga ? (
                      <span><LoadingOutlined spin /> Cargando imágenes, por favor espera...</span>
                    ) : (
                      <span>⚠️ Algunas imágenes no se cargaron correctamente. Revisa los campos con error.</span>
                    )}
                  </div>
                )}
          </div>
        </Form>
        </div>

        {/* Modal para ingresar el código SIRR */}
        <Modal
          title="Consultar Código SIRR"
          open={modalVisible}
          footer={null}
          closable={true}
          onCancel={() => {
            setModalVisible(false);
            onClose();
          }}
        >
          <Input
            placeholder="Ingrese el código SIRR"
            value={codigoSIRRModal}
            onChange={(e) => setCodigoSIRRModal(e.target.value)}
            style={{ marginBottom: "16px" }}
          />
          <Button type="primary" onClick={handleConsultar}>
            Consultar
          </Button>
        </Modal>
      </Card>
    </div>
  );
};

export default FormularioVisitaTecnica;
